import M from "materialize-css";

export class BtnTooltipController {
    // binded
    public class: string;
    public icon: string;
    public position: any = "bottom";
    public tooltip: string;

    private tooltipId: string;
    private tooltipInstance: any;

    public $onInit() {
        // generate unique id for component
        this.tooltipId = `tooltip-${Math.floor(Math.random() * Date.now())}`;

        angular.element(() => {
            this.tooltipInstance = M.Tooltip.init(
                document.querySelector(`#${this.tooltipId}`),
                { position: this.position }
            );
        });
    }

    public $onDestroy() {
        this.tooltipInstance.destroy();
    }
}
